export const language: any = {
  selected_ingredients: '已选食材',
  recommend: '推荐菜品',
  title_detail: '推荐食谱',
  share: '分享',
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">食材</span> <span class="tracking-tighter whitespace-nowrap">(1人份)</span>`,
    add_all: '添加所有食材',
    view_more: '查看更多 {number} 种食材',
    view_less: '折叠',
    delete_all: '删除所有食材',
  },
  how_to_cook: '烹饪方法',
  video: {
    title: '视频食谱',
  },
  msg: {
    msg_1: "确定要删除这个食材吗？",
    msg_2: "确定要删除所有食材吗？",
    msg_3: "是否添加这些食材？",
    msg_4: "是否添加所有缺少的食材？",
    msg_5: "是否将选中的食材添加到购物车？",
    msg_6: "该食材已经在购物车中了。",
    confirm: "是",
    cancel: "否",
  },
  recipe_exist_in_cart: "该食材已经在购物车中了。",
  recipe_want_add_to_cart: "是否将选中的食材添加到购物车？",
  recipe_exist_in_cart_should_exclued: "已在当前购物车中，因此被排除",
  calories_description: "此菜品根据以下食谱提供{calories}。请考虑健康选择！",
  title_share_sns: "在此平台分享这个食谱",
  copy: "复制",
  recipe_add_cart_success: "已加入购物车。您想转到购物车页面吗？",
  recipe_close: "关闭",
  recipe_move: "移动",
  recipe_add_ingredient_success: "所选食材已添加。您想切换到食材页面吗",
  copied: "已复制",
  text_share_sns: `{recipe_name} 这个食谱怎么样？快来 Hey! Cooker 上查看吧！`,
  search: {
    title: "搜索食谱",
    searching: "Hey Cooker 正在搜索与您的关键词匹配的食谱，<br/>请稍等片刻！",
    not_found: "嗯，AI厨师没有找到与您的关键词匹配的菜肴，<br/>请尝试输入其他菜肴名称。",
    placeholder: "输入您想要搜索的食谱名称...",
    msg_default_recipe: "您还没有任何食谱",
  },
  noData: "找不到结果",
  searching: "搜索中..."
}
